import { WebSocketService } from '../services/WebSocketService';

export default function setup() {
  window.addEventListener('beforeunload', () => {
    window.sessionStorage.tabId = window.tabId;
    return null;
  });
  
  const notificationClientId = window.sessionStorage.getItem(
    'notificationClientId',
  );

  if (window.sessionStorage.tabId) {
      window.tabId = window.sessionStorage.tabId;
      window.sessionStorage.removeItem('tabId');
      window.sessionStorage.tabChanged = false;
  } else {
    window.tabId = generateRandomID();
    window.sessionStorage.tabChanged = true;
  }

  if (notificationClientId && window.sessionStorage.tabChanged) {
    window.sessionStorage.removeItem('notificationClientId');
    if (brain.websockets.notificationsWS) brain.websockets.close();
  } else if (notificationClientId) {
    WebSocketService.closeConnectionFromRecipientAndClientId(
      brain.user.json.email,
      notificationClientId,
    );

    window.sessionStorage.removeItem('notificationClientId');
    if (brain.websockets.notificationsWS) brain.websockets.close();
  }

  window.sessionStorage.setItem(
    'notificationClientId',
    generateRandomID(),
  );

  brain.websockets.setupNotificationsWS();

  return brain.websockets.notificationsWS;
}

function generateRandomID() {
  return Date.now().toString(36) + Math.random().toString(36);
}